import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { libraryI18n, commonResources } from '@gofranz/common-components';

// Import formshive-specific translation files
import arUnique from './locales/ar-unique.json';
import deUnique from './locales/de-unique.json';
import enUnique from './locales/en-unique.json';
import esUnique from './locales/es-unique.json';
import frUnique from './locales/fr-unique.json';
import ptUnique from './locales/pt-unique.json';
import thUnique from './locales/th-unique.json';
import zhUnique from './locales/zh-unique.json';

// Import docs translation files
import arDocs from './locales/ar-docs.json';
import deDocs from './locales/de-docs.json';
import enDocs from './locales/en-docs.json';
import esDocs from './locales/es-docs.json';
import frDocs from './locales/fr-docs.json';
import ptDocs from './locales/pt-docs.json';
import thDocs from './locales/th-docs.json';
import zhDocs from './locales/zh-docs.json';

// Import integrations translation files
import arIntegrations from './locales/ar-integrations.json';
import deIntegrations from './locales/de-integrations.json';
import enIntegrations from './locales/en-integrations.json';
import esIntegrations from './locales/es-integrations.json';
import frIntegrations from './locales/fr-integrations.json';
import ptIntegrations from './locales/pt-integrations.json';
import thIntegrations from './locales/th-integrations.json';
import zhIntegrations from './locales/zh-integrations.json';

// Formshive-specific resources merged with common translations
// App components need access to common translations (glob_navigation, glob_footer, etc.)
const resources = {
  en: {
    translation: {
      ...commonResources.en,
      ...enUnique,
      ...enDocs,
      ...enIntegrations,
    },
  },
  de: {
    translation: {
      ...commonResources.de,
      ...deUnique,
      ...deDocs,
      ...deIntegrations,
    },
  },
  es: {
    translation: {
      ...commonResources.es,
      ...esUnique,
      ...esDocs,
      ...esIntegrations,
    },
  },
  fr: {
    translation: {
      ...commonResources.fr,
      ...frUnique,
      ...frDocs,
      ...frIntegrations,
    },
  },
  pt: {
    translation: {
      ...commonResources.pt,
      ...ptUnique,
      ...ptDocs,
      ...ptIntegrations,
    },
  },
  zh: {
    translation: {
      ...commonResources.zh,
      ...zhUnique,
      ...zhDocs,
      ...zhIntegrations,
    },
  },
  th: {
    translation: {
      ...commonResources.th,
      ...thUnique,
      ...thDocs,
      ...thIntegrations,
    },
  },
  ar: {
    translation: {
      ...commonResources.ar,
      ...arUnique,
      ...arDocs,
      ...arIntegrations,
    },
  },
};

// Initialize i18n instance for formshive
// Apps don't use LanguageDetector - they use synchronous init + detectAndSetLanguage in App.tsx
export const i18nInitPromise = i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: typeof window !== 'undefined'
      ? (localStorage.getItem('saved-language') || navigator.language.split('-')[0] || 'en')
      : 'en',
    fallbackLng: 'en',
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
  });

// Synchronize language changes between app and library i18n instances
// This ensures library components use the same language as the app
i18n.on('languageChanged', (lng) => {
  libraryI18n.changeLanguage(lng);
});

export default i18n;
